export function MomentsIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_2634_19976)">
        <path d="M1.72285 10.2273L8.08181 10.6666M14.2769 5.77251L7.90329 5.34091M5.75071 9.41615L2.93252 3.67473M10.2786 6.60239L13.0673 12.3251M5.64857 6.75795L9.21177 1.44807M10.3494 9.28368L6.788 14.5518M3.28581 3.28587C0.682309 5.88937 0.682309 10.1105 3.28581 12.714C5.8893 15.3174 10.1104 15.3174 12.7139 12.714C15.3174 10.1105 15.3174 5.88936 12.7139 3.28587C10.1104 0.682378 5.88929 0.682378 3.28581 3.28587ZM6.11422 6.1143C5.07282 7.1557 5.07282 8.84414 6.11422 9.88554C7.15561 10.9269 8.84406 10.9269 9.88546 9.88554C10.9269 8.84414 10.9269 7.1557 9.88546 6.1143C8.84406 5.0729 7.15561 5.0729 6.11422 6.1143Z" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2634_19976">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "MomentsIcon";
